import History from '../../containers/history/index'
import AppShell from '../../components/layout/AppShell'

export default function HistoryPage() {
    return (
        <AppShell title="История экспортов">
            <History />
        </AppShell>
    )
}
